/**
 * 计价表版本状态。**单点定义在这里,三端引用**(CLAUDE.md 硬约束「枚举单点定义」)。
 *
 * prisma/schema.prisma 里有一份同名的数据库枚举 —— 那是不得不有的第二处。
 * 两处的一致性不靠人记得:apps/api/src/common/enum-parity.ts 里有一条类型级断言,
 * 对不上 `pnpm typecheck` 直接失败。
 *
 * 三态的含义,以及为什么不是两态:
 *   draft     草稿。可以反复改数字,试算与下单都看不见它
 *   published 发布中。**同一时刻最多一版** —— 试算与下单只读这一版
 *   archived  已归档。发布新版时上一版进这里,不删
 *
 * archived 不许省掉:历史订单快照里存着旧版本号(M-02),
 * 删掉旧版之后那个版本号就指向空气,对账时没人能还原「当时按什么价收的」。
 */
export const PRICING_TABLE_STATUS = ['draft', 'published', 'archived'] as const

export type PricingTableStatus = (typeof PRICING_TABLE_STATUS)[number]

export function isPricingTableStatus(x: unknown): x is PricingTableStatus {
  return typeof x === 'string' && (PRICING_TABLE_STATUS as readonly string[]).includes(x)
}
